<template>
  <div class="form-control">
    <template v-if="!isEdit">
      <slot></slot>
      <a
        v-if="$store.getters.getPackage == 'premium' && !isCoachlab"
        href="javascript:void(0);"
        @click="isEdit = true"
      >
        <span :style="{ color: dark ? 'black' : '' }" class="fas fa-pencil-alt"></span>
      </a>
    </template>
    <template v-else>
      <template v-if="!combobox">
        <template v-if="type == 'text'">
          <input
            v-model="customer_value"
            style="color: black !important"
            type="text"
            class="form-control"
            :placeholder="placeholder"
            maxlength="600"
          />
        </template>
        <template v-if="type == 'textarea'">
          <textarea
            v-model="customer_value"
            style="color: black !important; resize: vertical"
            type="text"
            class="form-control"
            :placeholder="placeholder"
            maxlength="1500"
          />
        </template>
        <template v-if="type == 'number'">
          <input
            v-model="customer_value"
            type="number"
            class="form-control"
            :placeholder="placeholder"
            maxlength="600"
            @keypress="onlyNumber"
          />
        </template>
        <template v-else-if="type == 'dropdown'">
          <multiselect
            v-model="customer_value"
            :options="options"
            :searchable="false"
            :allow-empty="false"
            select-label
            selected-label
            deselect-label
          >
          </multiselect>
        </template>
        <template v-else-if="type == 'gender'">
          <multiselect
            v-model="customer_value"
            :options="options"
            :searchable="false"
            :allow-empty="false"
            :show-labels="false"
            select-label
            selected-label
            deselect-label
            label="label"
            track-by="value"
          >
          </multiselect>
        </template>
        <template v-else-if="type == 'date'">
          <v-dialog
            ref="dialog"
            v-model="showDate"
            :return-value.sync="customer_value"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template #activator="{ on }">
              <input
                v-model="customer_value"
                type="text"
                class="form-control"
                :placeholder="placeholder"
                readonly
                maxlength="600"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="customer_value" scrollable color="primary">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="showDate = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog.save(customer_value)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </template>
      </template>
      <multiselect
        v-else-if="combobox"
        v-model="customer_value"
        :options="selectOptions"
        :multiple="multiple"
        :taggable="true"
        :loading="loading"
        :internal-search="false"
        :custom-label="customLabel"
        @tag="addTag"
        @search-change="onSearch"
      >
      </multiselect>
      <div class="text-xs-center">
        <v-btn outline :color="dark ? 'white' : 'grey'" small @click="cancelEdit">{{
          $t('cancel')
        }}</v-btn>
        <v-btn depressed color="primary" small @click="saveEdit">{{ $t('Save') }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      default: undefined
    },
    userid: {
      default: undefined
    },
    placeholder: {
      default: ''
    },
    type: {
      default: 'text'
    },
    dark: {
      default: false
    },
    itemOption: {
      default: undefined
    },
    multiple: {
      default: false
    },
    combobox: {
      default: false
    },
    customLabel: {
      type: Function,
      default: undefined
    }
  },
  data: function () {
    return {
      showDate: false,
      isEdit: false,
      customer_value: '',
      loading: false,
      selectOptions: []
    }
  },
  watch: {
    value: function () {
      this.init()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    })
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init() {
      this.selectOptions = this.itemOption || []
      if (this.type == 'date') {
        this.customer_value = this.value
          ? moment(this.value).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD')
      } else if (this.type == 'gender') {
        if (this.value === 'male') {
          this.customer_value = {
            label: this.$t('Male'),
            value: 'male'
          }
        } else if (this.value === 'female') {
          this.customer_value = {
            label: this.$t('Female'),
            value: 'female'
          }
        } else {
          this.customer_value = { label: this.$t('no gender'), value: '' }
        }
      } else {
        this.customer_value = this.value
      }
      this.cached_customer_value = this.customer_value
    },
    onSearch(event) {
      const vm = this
      vm.loading = true
      vm.$emit('onSearch', {
        event,
        onComplete(options = []) {
          vm.selectOptions = options
          vm.loading = false
        }
      })
    },
    addTag(newTag) {
      this.itemOption.push(newTag)
      this.customer_value = newTag
    },
    onlyNumber(event) {
      var result = event.charCode >= 48 && event.charCode <= 57
      if (result) {
        // return result;
      } else {
        event.preventDefault()
      }
    },
    cancelEdit: function () {
      this.isEdit = false
      this.customer_value = this.cached_customer_value
    },
    saveEdit: function () {
      var vm = this
      var data = {
        pageid:
          vm.$route.name == 'allinonechat'
            ? vm.$store.state.livechat.pageid
            : vm.selectedBot.pageid,
        usersid: vm.userid,
        customer_value: vm.customer_value,
        onEdit: function () {
          vm.isEdit = false
          if (vm.type == 'gender') {
            vm.cached_customer_value = vm.customer_value.value
            vm.$emit('input', vm.customer_value.value)
          } else {
            vm.cached_customer_value = vm.customer_value
            vm.$emit('input', vm.customer_value)
          }
        }
      }
      vm.$emit('onEdit', data)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/EditCustomerValue.vue